import React from "react";

import { Route, Routes } from "react-router-dom";

import ContentLayout from "Components/ContentLayout";

import CertificateForm from "./components/CertificateForm/index";
import ProjectCertificateListField from "./components/ProjectCertificateListField";

const ProjectSettingsVariable = () => (
  <ContentLayout className="settings">
    <Routes>
      <Route path="add" element={<CertificateForm />} />
      <Route path="" element={<ProjectCertificateListField />} />
    </Routes>
  </ContentLayout>
);

export default ProjectSettingsVariable;
